import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { UnauthLayout as UnauthLayoutComponent } from '@/layouts'

/**
 * Unauth Layout Route (Pathless)
 *
 * Routes under this layout:
 * - /login
 * - /register
 *
 * The underscore prefix makes this route pathless - it provides layout
 * without contributing to the URL structure.
 *
 * Layout includes:
 * - Minimal centered wrapper for auth forms
 * - Branded logo in top-left corner
 * - No sidebar, no navigation chrome
 * - Responsive container optimized for auth forms
 */
export const Route = createFileRoute('/_unauth')({
  beforeLoad: async ({ location }) => {
    // Redirect authenticated users away from login/register pages
    const storedUserProfile = localStorage.getItem('user-profile')

    // Don't redirect if this is an OAuth callback (has 'code' and 'state' params)
    const searchParams = new URLSearchParams(location.search)
    const isOAuthCallback = searchParams.has('code') && searchParams.has('state')

    // Don't redirect if user is on pending-access page
    const isPendingAccessPage = location.pathname === '/pending-access'

    console.error('[ROUTE-GUARD] _unauth beforeLoad check:', {
      pathname: location.pathname,
      hasUserProfile: !!storedUserProfile,
      isOAuthCallback,
      isPendingAccessPage
    })

    // If user is authenticated and NOT processing OAuth callback and NOT on pending-access, redirect to app
    if (storedUserProfile && !isOAuthCallback && !isPendingAccessPage) {
      // Check if user has pending status - keep them on unauth routes
      const userProfile = JSON.parse(storedUserProfile)
      console.error('[ROUTE-GUARD] User profile status:', userProfile.status)
      if (userProfile.status === 'pending') {
        console.error('[ROUTE-GUARD] ⚠️ User has pending status, allowing access to unauth routes')
      } else {
        console.error('[ROUTE-GUARD] ✅ User already authenticated, redirecting to app')
        throw redirect({
          to: '/big-numbers',
        })
      }
    }

    console.error('[ROUTE-GUARD] 👤 User not authenticated or pending access, showing unauth page')
  },
  component: UnauthLayout,
})

function UnauthLayout() {
  return (
    <UnauthLayoutComponent>
      <Outlet />
    </UnauthLayoutComponent>
  )
}
